import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@mui/material/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import moment from 'moment';
import MaskedInput from 'react-text-mask';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import ClientTransactions from './ClientTransactions';
import RetrieveCredits from './RetrieveCredits';
import Tariffs from './Tariffs';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        textAlign: 'center',
        spacing: 10,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function AdminUpdateClient(props){

    const [client, setClient] = useState(
        props.currentClient
    );
    const [months, setMonths] = useState(0);
    //const [packageList, setPackageList] = useState(
    //    props.packages
    //);
    const clientSelector = useSelector((state) => state.clientReducer.name);
    const resellerSelector = useSelector((state) => state.clientReducer.client.reseller);
    const [reseller, setReseller] = useState(0);
    const [resellersList, setResellersList] = useState([]);
    const [dealer, setDealer] = useState(0);
    const [dealersList, setDealersList] = useState([]);
    const [dealerSelect, setDealerSelect] = useState("");
    const [resellerSelect, setResellerSelect] = useState("");
    const [server, setServer] = useState(0);
    const [packageSelection, setPackageSelection] = useState(8);
    const [packagesList, setPackagesList] = useState(props.packages);
    const [selectedPackages, setSelectedPackages] = useState({subs: []});
    const [newPassword, setNewPassword] = useState("");


    const classes = useStyles();

    useEffect(() => {
        props.onInitializeSaveClient();
        props.onInitializeRetrieveCredits();
        props.onGetClient(props.token, props.currentClientName);
        //props.onGetPackagesList(props.token);
        props.onGetShortResellerList(props.token);
        props.onGetDealerList(props.token);

    }, []);

    useEffect(() => {
        console.log('current client', props.currentClient);
        setClient(props.currentClient);
        setDealer(props.currentClient.dealer);
        setReseller(props.currentClient.reseller);
        setPackageSelection(props.currentClient.package_selection);
        setServer(props.currentClient.server);
        props.onSetTariff(props.currentClient.package_selection);
        //if (props.currentClient.package_selection === 3){
        //    props.onGetSubPackagesList(props.token, props.currentClientName);
        //}
    }, [props.currentClient]);

    useEffect(()=>{
        //console.log('LOGGING SERVER CHANGE:::', server);
        props.onGetPackagesList(props.token, server);
        if (props.currentClient.package_selection === 3){
            props.onGetSubPackagesList(props.token, props.currentClientName, server);
        }
    }, [server]);

    useEffect(()=>{
        if (props.packages && props.packages.length) {
            setPackagesList(props.packages);
        }
    }, [props.packages]);

    useEffect(()=>{
        setSelectedPackages({subs: props.subPackages});
    }, [props.subPackages]);

    useEffect(() => {
        if (props.resellers && props.resellers.length){
            console.log('inside resellers list');
            setResellersList(props.resellers);
            //setReseller(props.currentClient.reseller);
            //setDealer(props.currentClient.dealer);
        }
    },[props.resellers]);

    useEffect(() => {
        if (props.dealers && props.dealers.length){
            console.log('inside resellers list');
            setDealersList(props.dealers);
            //setReseller(props.currentClient.reseller);
            //setDealer(props.currentClient.dealer);
        }
    },[props.dealers]);

    useEffect(() => {
        //console.log('inside useEffect updateClient', props.tariff);
        setPackageSelection(props.tariff);
    }, [props.tariff]);

    useEffect(() => {
        if (props.isErrorSaveClient){
            var errorMessage = '' + props.isErrorSaveClient;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorSaveClient]);

    const handleToggle = (event) => {
        //const target = event.target;
        //const value = target.type === 'checkbox' ? target.checked : target.value;
        //const name = target.name;
        //const key = target.key;
        //setPackagesList({
        //    ...packagesList,
        //    [name]: {
        //        ...packagesList[name],
        //        checked: value
        //    }
        //})
        console.log('event name', event.target.name, ' value', event.target.value);
        const isChecked = event.target.checked;
        if (isChecked){
            setSelectedPackages({
                subs: [...selectedPackages.subs, event.target.value]
            });
        } else {
            const index = selectedPackages.subs.indexOf(event.target.value);
            selectedPackages.subs.splice(index,  1);
            setSelectedPackages({
                subs: selectedPackages.subs
            })
        }
    };

    function handleResellerChange(value){
        console.log('reseller selected', value);
        setReseller(value);
        setDealer(0);
        if (value === 0){
            setDealersList([]);
        } else {
            //console.log('dealers', props.dealers);
            let filteredDealersList = props.dealers.filter((dealer) => {
                return dealer.reseller === value;
            });

            setDealersList(filteredDealersList);
        }
    }

    let displayCustomPackages = null;
    if (packageSelection === 3){
        displayCustomPackages = (
            <Box sx={{ display: 'flex' }}>
                <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                    <FormLabel component="legend">Live Packages</FormLabel>
                    {Object.keys(packagesList).map((key,value) => {
                        if (packagesList[key].type === "tv") {
                            return (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            type="checkbox"
                                            onChange={handleToggle}
                                            key={key}
                                            value={packagesList[key].id}
                                            name="subs[]"
                                            label={packagesList[key].name}
                                            checked={(selectedPackages.subs.includes(packagesList[key].id))?true:false}
                                        />
                                    }
                                    label={packagesList[key].name}
                                />
                            );
                        }
                    })}
                </FormControl>
                <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                    <FormLabel component="legend">VOD Packages</FormLabel>
                    {Object.keys(packagesList).map((key,value) => {
                        if (packagesList[key].type === "video"){
                            return(
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            type="checkbox"
                                            onChange={handleToggle}
                                            key={key}
                                            value={packagesList[key].id}
                                            name="subs[]"
                                            label={packagesList[key].name}
                                            checked={(selectedPackages.subs.includes(packagesList[key].id))?true:false}
                                        />
                                    }
                                    label={packagesList[key].name}
                                />
                            );
                        }

                    })}
                </FormControl>
            </Box>)
    }


    function validateForm() {
        if (client.ministra){
            return client.description.length < 500 && client.phone.length < 15 && client.password.length > 1;
        } else {
            return client.mac.length === 17 && client.description.length < 500 && client.phone.length < 15 && client.password.length > 1;
        }

    }

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    const handleChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        const key = target.key;
        setClient({
            ...client,
            [name]: value
        })
    };


    function handleSubmit(event) {
        event.preventDefault();
        const data = {
            reseller: reseller,
            dealer: dealer,
            login: client.name,
            password: client.password,
            o_mac: client.o_mac,
            stb_mac: client.mac,
            ministra: client.ministra,
            months: months,
            desc: client.description,
            phone: client.phone,
            status: client.status,
            package_selection: packageSelection,
            packages: selectedPackages.subs,
            server: server
        };

        if (packageSelection === 3 && (selectedPackages.subs.length === packagesList.length || selectedPackages.subs.length < 1)) {
            var errorMessage = 'If you want to select all packages, then just select ALL PACKAGES from package selection.';
            if (selectedPackages.subs.length < 1) {
                errorMessage = 'Please select at least ONE package or select a pre-defined package from the package selection.';
            }
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else if (reseller === 0) {
            let errorMessage = 'A reseller will need to be selected';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else if (dealer === 0){
            let errorMessage = 'Please select a dealer';
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        } else {
            console.log('submit data', data);
            props.onSaveClient(props.token, data);
        }

    }

    let displayMacAddress = null;
    if (!client.ministra){
        displayMacAddress = (<FormControl>
            <MaskedInput
                mask={[/[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':', /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/]}
                className={classes.input}
                placeholder="Mac Address"
                value={client.mac}
                guide={true}
                id="mac"
                name="mac"
                onChange={handleChange}
            />
        </FormControl>);
    }

    let saveClientRedirect = null;
    if(props.isSuccessSaveClient){
        console.log('redirecting because', props.isSuccessSaveClient);
        props.onGetCredits(props.token);
        var successMessage = 'Updated ' + props.isSuccessSaveClient.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
        saveClientRedirect = <Redirect to="/manageclients" />
    }

    return (
        <div>
            {saveClientRedirect}
            <Container>
                <Grid container spacing={2}>
                    <Grid item sm={12}>
                    </Grid>
                    <Grid item sm={5} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Update Client"
                                            subheader={props.currentClient.name}
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                            subheaderTypographyProps={{
                                                fontSize: 14,
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <form>
                                                <FormGroup row>
                                                <FormControl className={classes.formControl} fullWidth>
                                                    <InputLabel id="select-server-label">Server</InputLabel>
                                                    <Select
                                                        id="server"
                                                        labelId="Select server"
                                                        value={server}
                                                        onChange={e => setServer(e.target.value)}
                                                    >
                                                        <MenuItem value={0} key="server_0">T4K</MenuItem>
                                                        <MenuItem value={1} key="server_1">COD 4K</MenuItem>
                                                        <MenuItem value={2} key="server_2">CROWN 4K</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <InputLabel id="select-reseller-label">Reseller</InputLabel>
                                                        <Select
                                                            id="reseller"
                                                            labelId="Select reseller"
                                                            value={reseller}
                                                            onChange={e => handleResellerChange(e.target.value)}
                                                        >
                                                            <MenuItem value={0}>Select Reseller</MenuItem>
                                                            {resellersList.map(item => {
                                                                return <MenuItem key={item.reseller} value={item.reseller}>{item.reseller}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <InputLabel id="select-dealer-label">Dealer</InputLabel>
                                                        <Select
                                                            id="dealer"
                                                            labelId="Select dealer"
                                                            value={dealer}
                                                            onChange={e => setDealer(e.target.value)}
                                                        >
                                                            <MenuItem value={0}>Select Dealer</MenuItem>
                                                            {dealersList.map(item => {
                                                                return <MenuItem key={item.dealer} value={item.dealer}>{item.dealer} [{item.credits} credits]</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControlLabel className={classes.formControl}
                                                                      control={
                                                                          <Switch
                                                                              checked={client.status}
                                                                              onChange={handleChange}
                                                                              id="status"
                                                                              name="status"
                                                                          />
                                                                      }
                                                                      label="Status"
                                                    />
                                                    <FormControlLabel className={classes.formControl}
                                                                      control={
                                                                          <Switch
                                                                              checked={(client.ministra === true)?true:false}
                                                                              onChange={handleChange}
                                                                              id="ministra"
                                                                              name="ministra"
                                                                          />
                                                                      }
                                                                      label="Ministra"
                                                    />
                                                </FormGroup>
                                                {displayMacAddress}
                                                <FormGroup>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <TextField
                                                            id="password"
                                                            name="password"
                                                            value={client.password}
                                                            label="Enter password"
                                                            onChange={handleChange}
                                                            type="text"
                                                        />
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <TextField
                                                            id="description"
                                                            name="description"
                                                            value={client.description}
                                                            label="Description"
                                                            onChange={handleChange}
                                                            type="text"
                                                            multiline
                                                            maxRows={4}
                                                        />
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControl>
                                                        <MaskedInput
                                                            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                                            className={classes.input}
                                                            placeholder="Enter a phone number"
                                                            value={client.phone}
                                                            guide={true}
                                                            id="phone"
                                                            name="phone"
                                                            onChange={handleChange}
                                                        />
                                                    </FormControl>
                                                </FormGroup>

                                                <FormGroup row>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <InputLabel id="select-months-label">Months</InputLabel>
                                                        <Select
                                                            id="months"
                                                            labelId="Select subscription"
                                                            onChange={e => setMonths(e.target.value)}
                                                            value={months}
                                                        >
                                                            <MenuItem value={0}>Add months</MenuItem>
                                                            <MenuItem value={1}>1 Month</MenuItem>
                                                            <MenuItem value={2}>2 Months</MenuItem>
                                                            <MenuItem value={3}>3 Months</MenuItem>
                                                            <MenuItem value={4}>4 Months</MenuItem>
                                                            <MenuItem value={5}>5 Months</MenuItem>
                                                            <MenuItem value={6}>6 Months</MenuItem>
                                                            <MenuItem value={7}>7 Months</MenuItem>
                                                            <MenuItem value={8}>8 Months</MenuItem>
                                                            <MenuItem value={9}>9 Months</MenuItem>
                                                            <MenuItem value={10}>10 Months</MenuItem>
                                                            <MenuItem value={11}>11 Months</MenuItem>
                                                            <MenuItem value={12}>12 Months</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <InputLabel id="select-package-label">Package</InputLabel>
                                                        <Tariffs s={server} />
                                                    </FormControl>
                                                </FormGroup>
                                                {displayCustomPackages}
                                            </form>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                block
                                                disabled={!validateForm() || props.isLoadingSaveClient}
                                                type="submit"
                                                onClick={handleSubmit}
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                fullWidth
                                            >
                                                {props.isLoadingSaveClient
                                                    ? spinner
                                                    : 'Update'}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Paper>
                            </Grid>
                            <Grid item sm={12} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <RetrieveCredits role="admin" client={clientSelector}/>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={7} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <ClientTransactions role="admin" client={clientSelector} />
                                </Paper>
                            </Grid>
                            <Grid item sm={12} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Device Information"
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                            subheaderTypographyProps={{
                                                fontSize: 14,
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Expiry"
                                                    secondary={moment(props.currentClient.expiry).format('ddd, MMM Do YYYY')}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Last updated"
                                                    secondary={moment(props.currentClient.last_updated).format('ddd, MMM Do YYYY hh:mm a')}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Password"
                                                    secondary={props.currentClient.password}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Stb Serial"
                                                    secondary={props.currentClient.stb_sn}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Stb Type"
                                                    secondary={props.currentClient.stb_type}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Stb Version"
                                                    secondary={props.currentClient.version}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary="Last seen"
                                                    secondary={moment(props.currentClient.last_active).format('ddd, MMM Do YYYY hh:mm a')}
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary={props.currentClient.online}
                                                />
                                            </ListItem>
                                        </CardContent>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )

}

const mapDispatchToProps = dispatch => {
    return {
        onGetClient: (token, name) => dispatch(actions.getClientAdmin(token, name)),
        onGetPackagesList: (token, server) => dispatch(actions.packagesListAdmin(token, server)),
        onGetSubPackagesList: (token, name) => dispatch(actions.subPackagesListAdmin(token, name)),
        onSaveClient: (token, data) => dispatch(actions.saveClientAdmin(token, data)),
        onInitializeSaveClient: () => dispatch(actions.initializeSaveClient()),
        onInitializeRetrieveCredits: () => dispatch(actions.initializeRetrieveCredits()),
        onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        onGetDealerList: (token) => dispatch(actions.dealerListAdmin(token)),
        onGetShortResellerList: (token) => dispatch(actions.resellerListShortAdmin(token)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message)),
        onSetTariff: (packageSelection) => dispatch(actions.setTariff(packageSelection))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        packages: state.packages.package_list,
        subPackages: state.subPackages.sub_package_list,
        isLoading: state.packages.loading,
        currentClientName: state.clientReducer.name,
        isLoadingSaveClient: state.saveClient.loading,
        currentClient: state.clientReducer.client,
        isErrorSaveClient: state.saveClient.error,
        isSuccessSaveClient: state.saveClient.client,
        dealers: state.dealers.dealer_list,
        resellers: state.resellers.reseller_list,
        tariff: state.tariff.tariff_plan
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdateClient);